export enum CareerType {
  COLLEGE_PLAYER = "CollegePlayer",
  PROSPECT = "Prospect"
}
